<template>
  <nav>
    <v-dialog
      v-if="newEmailTemp == null"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template
        v-if="canEditProfile && !signupFromGoogle"
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          data-testid="edit-email-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-user-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateEmail"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editUserEmailTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateEmail"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <v-text-field
                    v-model="currentPassword"
                    data-testid="password-current-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :placeholder="$t('editUserCurrentPasswordPlaceholder')"
                    :rules="passwordRules"
                    @click:append="showPassword = !showPassword"
                  />
                  <br>
                  <v-text-field
                    v-model="email"
                    data-testid="email-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :placeholder="$t('editUserEmailPlaceholder')"
                    :rules="emailRules"
                  />
                  <v-text-field
                    v-model="confirmEmail"
                    data-testid="email-confirm-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :placeholder="$t('editUserConfirmEmailPlaceholder')"
                    :rules="emailRules.concat(emailConfirmationRule)"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-else
      v-model="dialogPreventUpdate"
      max-width="400"
      overlay-color="darktext"
      overlay-opacity="0.6"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="edit-email-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          {{ $t('confirmationDialogTitleNotAllowedEmailChange') }}
        </v-card-title>
        <v-card-text>
          {{ $t('confirmationDialogTextNotAllowedEmailChange') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            ref="cancel"
            data-testid="cancel-button"
            color="accent"
            width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none"
            @click="dialogPreventUpdate=false"
          >
            {{ $t('okay') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateUser } from '../../api/userApi'
import { ruleRequired, emailRuleValid } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'
export default {
    components: {
        AlertMessages
    },
    props: {
        newEmailTemp: {
          type: String,
          default : ''
        }
    },
    data(){
        return{
            dialog: false,
            dialogPreventUpdate: false,
            valid: true,
            showPassword: false,
            currentPassword: '',
            email: '',
            confirmEmail: '',
            emailRules: ruleRequired('labelEmail').concat(emailRuleValid),
            passwordRules: ruleRequired('labelPassword'),
            alertMsg: '',
            alertValue:false,
            userId: window.$cookies.get('id'),
            canEditProfile: localStorage.user ? JSON.parse(localStorage.user).can_edit_profile : true,
            signupFromGoogle: localStorage.user ? JSON.parse(localStorage.user).signup_google : false,
            loading: false,
         }
    },
    computed: {
        emailConfirmationRule() {
            return () =>
                this.email === this.confirmEmail || i18n.t('fieldErrorMatch', {'field': i18n.t('labelEmail') })
        }
    },
    methods: {
        async updateEmail(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "users", 
                            id: this.userId,
                            attributes: {
                                password_current: this.currentPassword.trim(),
                                new_email_temp: this.email.trim(),
                                new_email_temp_confirmation: this.confirmEmail.trim()
                            }
                        }
                    };
                    const response = await updateUser(this.userId, data)
                    if(response.status == 200) {
                        this.alertValue =true
                        alertMsg = i18n.t('editUserEmailSuccess', {'email': this.email})
                        alertType = 'warning'
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.$emit('proceedEmail', this.email, response.data.data.attributes)
                        this.reloadForm()
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue =true
                       if(e.response.status == 460){
                            this.alertMsg = i18n.t('editUserErrorEmailAlreadyTaken')
                        }else if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The password current did not match!'){
                                    this.alertMsg = i18n.t('editUserErrorWrongCurrentPassword')
                                }else{
                                    alertType = 'error'
                                    alertMsg =  i18n.t('serverError')
                                    this.$emit('proceedSubmit', alertMsg, alertType)
                                    this.reloadForm()
                                }
                            }
                        }
                        else {
                            alertType = 'error'
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', alertMsg, alertType)
                            this.reloadForm()
                        }
                    }
                }
                this.loading = false
            }
        },
        reloadForm(){
            this.dialog = false
            this.alertValue = false
            this.alertMsg = ''
            this.$refs.form.reset()
        }
    }
}
</script>